export default "__VITE_ASSET__D6Uo3Ej$__"